angular.module("appVersion", [])
.constant("version", "4.57.2026091-7.5");
